// noinspection DuplicatedCode

import { InvoiceStatusRow } from '@components'
import {
  getInvoiceStatusName,
  invoiceStatuses,
  prepareInvoiceStatusOptions,
  useGetUserLanguageQuery
} from 'mmfintech-backend-api'
import { useOutsideClick } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import type { IInvoiceStatusProps } from './InvoiceStatus.types.ts'

import './invoiceStatus.scss'

export const InvoiceStatus = ({ value, overdue, onChange }: IInvoiceStatusProps) => {
  const [selectedOption, setSelectedOption] = useState(null)
  const [translatedOptions, setTranslatedOptions] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const { data: selectedLanguage } = useGetUserLanguageQuery()
  const ref = useOutsideClick(() => {
    setIsOpen(false)
  })

  useEffect(() => {
    const options =
      value === invoiceStatuses.OPENED
        ? [invoiceStatuses.PAID, invoiceStatuses.CANCELED]
        : value === invoiceStatuses.CANCELED
          ? [invoiceStatuses.OPENED, invoiceStatuses.PAID]
          : []
    setTranslatedOptions(prepareInvoiceStatusOptions(options))

    setSelectedOption(selectedOption)
    // eslint-disable-next-line
  }, [value, selectedLanguage])

  useEffect(() => {
    setSelectedOption(getInvoiceStatusName(value, overdue))
  }, [value, overdue])

  const handleChange = (selectedOption: any) => {
    onChange?.(selectedOption?.value)
  }

  return (
    <div className='invoiceStatusWrapper' ref={ref}>
      <div onClick={() => setIsOpen(!isOpen)} className='invoiceStatusAction'>
        <InvoiceStatusRow data={{ label: selectedOption, value: selectedOption?.toUpperCase() }} isOpen={isOpen} />
      </div>
      {isOpen && (
        <div className='options'>
          {translatedOptions.map(({ value, label }) => (
            <div key={value} onClick={() => handleChange({ value, label })} className='option'>
              <InvoiceStatusRow data={{ label, value }} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
